import { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { css, StyleSheet } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import { useLayoutEffect } from 'react'

const styles = StyleSheet.create({
  container: {
    lineHeight: '1.2em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
  },
  button: {
    padding: '4px',
    border: 'none',
    fontWeight: 'bold',
    background: 'none',
  },
})
const UILimitedText = ({ text, maxLines }) => {
  const { t } = useTranslation('limitedText')
  const divRef = useRef(null)
  const [isTextOverflowing, setIsTextOverflowing] = useState(false)
  const [height, setHeight] = useState('auto')
  const [needButton, setNeedButton] = useState(false)

  let calculatedHeight, maxHeight
  useLayoutEffect(() => {
    const styles = window.getComputedStyle(divRef.current)
    const fontSize = styles.fontSize.slice(0, styles.fontSize.length - 2)

    const lineHeightValue = styles.lineHeight
    const lineHeight =
      lineHeightValue === 'normal'
        ? fontSize * 1.5
        : styles.lineHeight.slice(0, styles.lineHeight.length - 2)

    maxHeight = lineHeight * maxLines
    calculatedHeight = divRef.current.clientHeight

    setNeedButton(calculatedHeight > maxHeight)
    setHeight(isTextOverflowing ? calculatedHeight : 'auto')
  }, [isTextOverflowing])

  const renderButtonLogic = () => {
    return !isTextOverflowing ? (
      <button
        className={css(styles.button)}
        onClick={() => setIsTextOverflowing(true)}
      >
        {t('more')}
      </button>
    ) : (
      <button
        className={css(styles.button)}
        onClick={() => setIsTextOverflowing(false)}
      >
        {t('less')}
      </button>
    )
  }

  return (
    <>
      <div
        className={css(styles.container)}
        style={{
          height,
          '-webkit-line-clamp': !isTextOverflowing ? `${maxLines}` : 'unset',
        }}
        ref={divRef}
      >
        {text}
      </div>
      {needButton ? renderButtonLogic() : <></>}
    </>
  )
}

UILimitedText.propTypes = {
  text: PropTypes.string.isRequired,
  maxLines: PropTypes.number,
}

UILimitedText.defaultProps = {
  text: '',
  maxLines: 3,
}

export default UILimitedText
